import styled from 'styled-components';
import media from '../../constants/media';
import { A } from '../base/typography';

export const Wrapper = styled.div`
	display: flex;

	${media.mobileOnly`
		display: none;
	`};
`;

export const IconWrapper = styled.div`
	margin-right: 1.5rem;
`;

export const Breadcrumb = styled.div`
	display: flex;
	align-items: center;
`;

export const BreadcrumbLink = styled(A)`
	font-size: 1.4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.black};
`;

export const BreadcrumbSep = styled.div`
	margin: 0 1.5rem;
`;
